import { ExportField, Frequency, ReportType } from "PFApp/booking/types/export_booking";

export const filtersKeys = {
  all: () => ["exportFilters"],
  reportType: (type: ReportType) => [...filtersKeys.all(), type]
};

export const fieldsKeys = {
  all: () => ["exportFields"],
  reportType: (type: ReportType, frequency: Frequency) => [...fieldsKeys.all(), type, frequency]
};

export const exportDataKeys = {
  all: () => ["exportData"],
  fields: (fields: ExportField[]) => [...exportDataKeys.all(), JSON.stringify(fields)]
};

export const exportTemplatesKeys = {
  all: () => ["exportTemplates"],
  create: () => [...exportTemplatesKeys.all(), "create"]
};

export const generateReportKeys = {
  all: () => ["generateReport"],
  generate: () => [...generateReportKeys.all(), "generate"]
};
